import { css } from '@emotion/css';

export const fileLink = css`
  text-decoration: none !important;
`;
